export default __webpack_public_path__ + "6185b65b65d6d374407356e6633f4e2d.png";